import { render } from "./SearchHighlighter.vue?vue&type=template&id=a9fd1326&scoped=true"
import script from "./SearchHighlighter.vue?vue&type=script&lang=js"
export * from "./SearchHighlighter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9fd1326"]])

export default __exports__